(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    // Loop Subscription Widget variant change handler
  document.addEventListener('variant:change', function(evt) {
    const inputElement = document.querySelector('input[name="product-id"]');
    const productId = inputElement.value
    const variantId = evt.detail.variant.id 
    window.LoopSubscriptions.handleLoopWidgetVariantIdChange(productId, variantId);
  });
  } catch(e) { console.error(e); }
})();

})();
